// extracted by mini-css-extract-plugin
module.exports = {"container":"no-search-result_container__2aDrY","icon":"no-search-result_icon__313Z7","title":"no-search-result_title__2Hf3U","text":"no-search-result_text__1eZ2W"};